export const SYM_MARKER = 'sym';

export const CONTENT_HEIGHT_SAFETY_PX = 4;
